<template>
<widget title="QR Codes" icon="fa-qrcode">

	<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

	<div class="row no-gutters justify-content-between p-2">

		<div class="card col-md-4 mr-3">
			<div class="card-body p-4">

				<h4>Generate QR Code</h4>

				<field
					label="Type"
					col-class="col-4"
					class="mt-4"
					:params="{type: 'select', options: recordTypeOptions}"
					v-model="recordType">
				</field>

				<job-picker
					v-if="recordType == 'project'"
					col-class="col-4"
					job-type="project"
					key="project"
					v-model="projectId"
					v-on:change="projectSelected">
				</job-picker>

				<job-picker
					v-else-if="recordType == 'service'"
					col-class="col-4"
					job-type="service"
					key="service"
					v-model="serviceId"
					v-on:change="serviceSelected">
				</job-picker>

				<template v-else-if="recordType == 'equipment'">

					<field
						label="Equipment Type"
						col-class="col-4"
						:params="{type: 'select', options: equipmentTypeOptions}"
						v-on:change="fetchEquipmentsWithType"
						v-model="equipmentTypeId">
					</field>

					<template v-if="equipmentTypeId">

						<field
							v-if="equipmentOptions.length"
							label="Equipment"
							col-class="col-4"
							:params="{type: 'select', options: equipmentOptions}"
							v-model="equipmentId">
						</field>

						<span v-else>No equipment items found with this type.</span>

					</template>
				</template>

				<template v-else-if="recordType == 'customer-asset'">

					<field
						label="Customer"
						col-class="col-4"
						:params="{type: 'select', options: optionify(customers, 'name')}"
						v-model="customerId">
					</field>

					<field
						v-if="customerId"
						label="Asset"
						col-class="col-4"
						:params="{type: 'select', options: customerAssetOptions}"
						v-model="customerAssetId">
					</field>
				</template>

				<field
					v-else-if="recordType == 'user-profile'"
					label="Employee"
					col-class="col-4"
					:params="{type: 'select', options: userOptions(false, $store.employees)}"
					v-model="userId">
				</field>

				<div v-if="mutatedCodeRecord && codeURL" class="d-flex justify-content-between mt-4 pt-2">
					<vue-qr-code
						:params="{text: codeURL, width: 250, height: 250}"
						:logo-url="logoSrc"
						logo-classes="p-1 rounded"
						:title="mutatedCodeRecord.title"
						:show-copy-button="true">
					</vue-qr-code>

				</div>
				<div class="text-center">
					<small><a :href="codeURL" class="text-muted" target="_blank">{{ codeURL }}</a></small>
				</div>

			</div>
		</div>

		<div class="card col-md">
			<div class="card-body p-4">

				<div class="d-flex justify-content-between flex-wrap">
					<h4>Create Static Link</h4>

					<button class="btn btn-primary" v-on:click="openEditModal()">
						<i class="fa fa-plus"></i>
						New Link
					</button>
				</div>


				<table-list
					:records="mutatedLinks"
					:fields="tableFields"
					record-name="link"
					:hide-record-count="true"
					:sortable="true"
					:has-edit="true"
					:has-delete="true"
					delete-endpoint="CompanyLink/delete"
					:other-buttons="[
						{
							text: 'Copy Link',
							icon: 'fa-copy',
							click: 'copyLink',
							class: 'btn-light',
							condition: ['hasLink', true]
						},
						{
							text: 'View Code',
							icon: 'fa-qrcode',
							click: 'openViewCodeModal',
							class: 'btn-light',
							condition: ['hasLink', true]
						}
					]"
					:collapse-buttons="true"
					v-on:edit="openEditModal"
					v-on:delete="fetchCompanyLinks()"
					v-on:copyLink="copyLink"
					v-on:openViewCodeModal="openViewCodeModal">

				</table-list>

			</div>
		</div>
	</div>


	<modal-dialog
		:modal-visible="editModal.visible"
		:title="editModal.title"
		v-on:closeModal="editModal.visible = false"
		v-on:confirm="saveLink">

		<field
			label="Name"
			col-class="col-md-4"
			v-model="editModal.payload.name">
		</field>

		<field
			label="Link"
			col-class="col-md-4"
			v-model="editModal.payload.link">
		</field>

	</modal-dialog>


	<modal-dialog
		:modal-visible="viewCodeModal.visible"
		title="QR Code"
		:submit-visible="false"
		v-on:closeModal="viewCodeModal.visible = false">

		<div v-if="viewCodeModal.record" class="d-flex justify-content-between">
			<vue-qr-code
				v-if="'link' in viewCodeModal && viewCodeModal.link"
				:params="{text: viewCodeModal.link, width: 250, height: 250}"
				:logo-url="logoSrc"
				logo-classes="p-1 rounded"
				:title="viewCodeModal.record.name">
			</vue-qr-code>
		</div>
	</modal-dialog>


</widget>
</template>
<script type="text/javascript">

import Widget from "@/components/Widget"
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import JobPicker from "@/components/super_components/JobPicker"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

import VueQrCode from "@/components/VueQrCode"


export default {
	name: "QrCodeManagerWidget",
	components: {
		Widget,
		Field,
		TableList,
		ModalDialog,
		VueQrCode,
		JobPicker,
		FreemiumLockedAlert
	},
	data() {
		return {

			tableFields: [
				{ label: "Name",          key: "name" },
				{ label: "Link URL",      key: "shortLink" },
				{ label: "Created At",    key: "createdAt",  sortBy: "date" },
			],

			links: [],
			customers: [],

			recordTypes: [
				{ key: 'project',            name: 'Project'},
				{ key: 'service',            name: 'Service'},
				{ key: 'equipment',          name: 'Equipment'},
				{ key: 'customer-asset',     name: 'Customer Asset'},
				{ key: 'user-profile',       name: 'User Profile'}
			],

			recordType: null,      // "Project", "Service", etc

			projectId: null,
			serviceId: null,
			project: {},
			service: {},
			equipmentTypeId: null,
			equipmentId: null,
			customerId: null,
			customerAssetId: null,
			userId: null,

			routeRecordId: null,


			editModal: {
				visible: false,
				record: {},
				payload: {}
			},

			viewCodeModal: {
				visible: false,
				linkRecord: false,
				link: false
			}
		}
	},
	computed: {
		codeURL() {
			if (this.mutatedCodeRecord && 'slug' in this.mutatedCodeRecord && this.mutatedCodeRecord.slug) {
				const type = this.recordTypes.find(type => type.key == this.recordType)
				return this.buildRedirectLink(type.key, this.mutatedCodeRecord.slug)
			}
			return ""
		},
		mutatedCodeRecord() {

			const type = this.recordTypes.find(type => type.key == this.recordType)

			let record = false
			let title = (type) ? type.name : ""

			if (this.recordType == 'project') {
				record = this.project

				if (record && 'job_num' in record && record.job_num)
					title += " - #" + record.job_num

			} else if (this.recordType == 'service') {
				record = this.service

				if (record && 'job_num' in record && record.job_num)
					title += " - #" + record.job_num

			} else if (this.recordType == 'equipment') {
				record = this.$store.equipments.find(rec => rec.id == this.equipmentId)

				if (record && 'description' in record && record.description)
					title = "Serial #" + record.serial_num     // do not show "Equipment - " in title

			} else if (this.recordType == 'customer-asset') {
				const customer = this.customers.find(c => c.id == this.customerId)
				if (customer && 'CustomerAsset' in customer && customer.CustomerAsset) {
					record = customer.CustomerAsset.find(rec => rec.id == this.customerAssetId)

					if (record && 'description' in record && record.description)
						title = "Serial #" + record.serial_num   // do not show "Customer Asset - " in title
				}

			} else if (this.recordType == 'user-profile') {
				record = this.$store.employees.find(rec => rec.id == this.userId)

				if (record) {
					let tokens = []
					if ('first_name' in record && record.first_name)
						tokens.push(record.first_name)
					if ('last_name' in record && record.last_name)
						tokens.push(record.last_name)

					if (this.$store.company && 'company_name' in this.$store.company && this.$store.company.company_name) {
						if (tokens.length)
							tokens.push(" - "+this.$store.company.company_name)
						else
							tokens.push(this.$store.company.company_name)
					}

					title = tokens.join(" ")   // do not show "User Profile - " in title
				}
			}

			if (record)
				record.title = title

			return record
		},
		logoSrc() {
			return '/resources/icons/logo_dark_icon_192.png'
		},
		mutatedLinks() {
			return this.links.map(link => {

				link.hasLink = Boolean(link.link)

				link.shortLink = link.link
				if (link.shortLink.length > 60)
					link.shortLink = link.shortLink.slice(0, 60) + "..."

				link.createdAt = this.formatDateTimeToLocal(link.created_at)
				return link
			})
		},
		customerAssetOptions() {
			const customer = this.customers.find(customer => customer.id == this.customerId)
			if (customer && 'CustomerAsset' in customer && customer.CustomerAsset)
				return this.optionify(customer.CustomerAsset, 'description')
			return []
		},
		recordTypeOptions() {
			return this.recordTypes.map(recordType => {
				return { text: recordType.name,  value: recordType.key }
			})
		}
	},
	methods: {
		openViewCodeModal(record) {
			this.viewCodeModal.record = record
			this.viewCodeModal.link = (!('slug' in record || !record.slug)) ? "" :
				this.buildRedirectLink("company-link", record.slug)
			this.viewCodeModal.visible = true
		},
		saveLink() {
			let vm = this

			this.postData('CompanyLink/save', this.editModal.payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess('Link saved')
					vm.fetchCompanyLinks()
					vm.editModal.visible = false
				}
			})
		},
		openEditModal(record) {

			if (record) {
				this.editModal.title = "Edit Link"
				this.editModal.record = record
				this.editModal.payload = this.cloneObj(record)

			} else {
				this.editModal.title = "New Link"
				this.editModal.record = {link: "", name: ""}
				this.editModal.payload = {link: "", name: ""}
			}

			this.editModal.visible = true
		},
		copyLink(code) {
			this.copyToClipboard(code.link)
			this.alertSuccess("Copied to clipboard")
		},
		projectSelected(id) {
			let vm = this
			this.getJSON("Job/find/" + id).then(response => {
				if (response.success)
					vm.project = response.data
			})
		},
		serviceSelected(id) {
			let vm = this
			this.getJSON("Service/find/" + id).then(response => {
				if (response.success)
					vm.service = response.data
			})
		},
		fetchEquipmentsWithType(typeId) {
			if (typeId) {
				const filters = [['type_id', typeId]]
				this.fetchEquipment(filters).then()
			}
		},
		fetchCompanyLinks() {
			let vm = this

			this.getJSON("CompanyLink/get").then(response => {
				if (response.success) {
					vm.links = response.data
				}
			})
		},
		fetchData() {
			let vm = this

			const contactPayload = {
				filters: [
					['is_customer', 1],
					['CustomerAsset', true]
				],
				include: [
					{ model: 'CustomerAsset', fields: ['description', 'serial_num'] },
				]
			}

			let promises = [
				this.getJSON("Contact/get", contactPayload)
			]

			if (!this.$store.equipmentTypes.length)
				promises.push(this.fetchEquipmentTypes())

			if (!this.$store.customers.length)
				promises.push(this.fetchCustomers(true))

			let fetchEmployees = false;
			if (!this.$store.employees.length) {
				promises.push(this.fetchUsers(false, false, false, ["Company"]))
				fetchEmployees = true
			}

			Promise.all(promises).then(responses => {
				if (responses[0].success)
					vm.customers = responses[0].data

				if (fetchEmployees && responses[responses.length-1].success)
					vm.$store.employees = responses[responses.length-1].data
			})
		}
	},
	created() {
		this.fetchCompanyLinks()
		this.fetchData()
	}
}
</script>